<template>
  <slot />

  <Teleport to="body">
    <Transition name="tooltip-fade">
      <div
        v-if="tooltip.open"
        ref="tooltipElement"
        class="floating-tooltip"
        :class="`placement-${tooltip.placement}`"
        :style="{ left: tooltip.x + 'px', top: tooltip.y + 'px' }"
        role="tooltip"
      >
        {{ tooltip.text }}
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { provide, onBeforeUnmount } from 'vue'
import { useFloatingTooltip } from '@/composables/useFloatingTooltip.js'

const { tooltip, tooltipElement, openTooltip, closeTooltip } = useFloatingTooltip()

provide('tooltip', { openTooltip, closeTooltip })

onBeforeUnmount(() => closeTooltip())
</script>

<style scoped>
.floating-tooltip {
  position: fixed;
  background-color: rgba(255, 255, 255, 0.95);
  border: none;

  min-width: 100px;
  max-width: 150px;
  height: auto;
  overflow: visible;

  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
  padding: var(--space-2);
  
  z-index: 9999;
  pointer-events: none;
  white-space: nowrap;

  text-shadow: 0 1px 3px rgba(0, 0, 0, .02);

  font-family: var(--font-body);
  font-weight: 500;
  font-size: 0.75rem;
  color: var(--color-text);
  text-transform: none;
  line-height: 125%;
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);

  box-sizing: border-box;

  transition: opacity 0.15s ease-in-out;
}

.floating-tooltip.placement-right {
  transform: translate(calc(5% + var(--space-2)), -75%);
}

.floating-tooltip.placement-left {
  transform: translate(calc(-110% - var(--space-2)), -75%);
}

.floating-tooltip::before {
  content: '';
  position: absolute;
  top: 75%;
  transform: translateY(-75%);
  width: 0;
  height: 0;
  border: 6px solid transparent;
}
.floating-tooltip.placement-right::before {
  left: -12px; /* position before the tooltip box */
  border-right-color: rgba(255, 255, 255, 0.95);
}
.floating-tooltip.placement-left::before {
  right: -12px; /* position before the tooltip box */
  border-left-color: rgba(255, 255, 255, 0.95);
}
</style>